import { mergeStoredKycUploadFlag, nextCkycVerificationFromPayload } from "helper/kycDocumentUpload";
import persistReducer from "redux-persist/lib/persistReducer";
import storage from "redux-persist/lib/storage";

import { jarvisPrimeOnboardingConstants } from "./jarvisPrimeOnboardingConstants";

const initialState = {
  currentStagePrime: 0,
  riskMasterId: null,
  riskProfileName: null,
  suggestedRiskId: null,
  investmentAmount: null,
  investmentTenure: null,
  investmentStrategy: null,
  isPrimeOnboardingCompleted: 0,
  isPaymentCompleted: 0,
  minInvestmentAmount: 2500000,
  minimumAdditionalInvestAmount: 200000,
  portfolioGeneratedDate: null,
  hasOnboardingInvestmentDetailsConfirmed: 0,
  expiryDate: null,
  dateOfBirth: null,
  pan: null,
  planId: null,
  aadharNumber: null,
  isPanUploaded: 0,
  isAadhaarFrontUploaded: 0,
  isAadhaarBackUploaded: 0,
  panVerification: "",
  aadharFrontVerification: "",
  aadharBackVerification: "",
  customerSubscriptionId: null,
  isMobileVerified: null,

  portfolioData: [],
  marketBreakupData: [],
  sectorBreakupData: [],
  pricingData: {},

  isInitialFetched: 0,
  loading: {
    primeOnboardingData: 0,
    portfolioData: 0,
    pricingData: 0,
  },
};

export const jarvisPrimeOnboardingReducer = persistReducer(
  {
    storage,
    key: "primeOnboarding",
    blacklist: [
      "portfolioData",
      "marketBreakupData",
      "sectorBreakupData",
      "pricingData",
      "loading",
      "rmsOnboarding",
      "rmsOnboardingSteps",
      "isInitialFetched",
      "isMobileVerified",
    ],
  },
  (state = initialState, { type, payload }) => {
    switch (type) {
      case jarvisPrimeOnboardingConstants.PRIME_UPDATE_ONBOARDING_DATA: {
        return {
          ...state,
          currentStagePrime:
            payload.currentStagePrime ?? state.currentStagePrime,
          riskMasterId: payload.riskMasterId ?? state.riskMasterId,
          riskProfileName: payload.riskProfileName ?? state.riskProfileName,
          suggestedRiskId: payload.suggestedRiskId ?? state.suggestedRiskId,
          investmentAmount: payload.investmentAmount ?? state.investmentAmount,
          investmentTenure: payload.investmentTenure ?? state.investmentTenure,
          investmentStrategy: [undefined, null].includes(
            payload.investmentStrategy,
          )
            ? state.investmentStrategy
            : payload.investmentStrategy,
          isPrimeOnboardingCompleted:
            payload.isPrimeOnboardingCompleted ??
            state.isPrimeOnboardingCompleted,
          isPaymentCompleted:
            payload.isPaymentCompleted ?? state.isPaymentCompleted,
          minInvestmentAmount:
            payload.minInvestmentAmount ?? state.minInvestmentAmount,
          minimumAdditionalInvestAmount:
            // payload.minimumAdditionalInvestAmount ??
            // state.minimumAdditionalInvestAmount,
            (payload.minimumAdditionalInvestAmount && Number(payload.minimumAdditionalInvestAmount) !== 10000) ?
              payload.minimumAdditionalInvestAmount : 200000,
          portfolioGeneratedDate:
            payload.portfolioGeneratedDate ?? state.portfolioGeneratedDate,
          expiryDate: payload.expiryDate ?? state.expiryDate,
          isInitialFetched: payload.isInitialFetched ?? state.isInitialFetched,
          planId: payload.planId ?? state.planId,
          hasOnboardingInvestmentDetailsConfirmed:
            payload.hasOnboardingInvestmentDetailsConfirmed ??
            state.hasOnboardingInvestmentDetailsConfirmed,
          customerSubscriptionId:
            payload.customerSubscriptionId ?? state.customerSubscriptionId,
          isMobileVerified: payload.isMobileVerified ?? state.isMobileVerified,
          dateOfBirth: payload.dateOfBirth ?? state.dateOfBirth,
          pan: payload.panNumber ?? payload.pan ?? state.pan,
          aadharNumber: payload.aadharNumber ?? state.aadharNumber,
          isPanUploaded: mergeStoredKycUploadFlag(
            state.isPanUploaded,
            payload.isPanUploaded,
          ),
          isAadhaarFrontUploaded: mergeStoredKycUploadFlag(
            state.isAadhaarFrontUploaded,
            payload.isAadhaarFrontUploaded,
          ),
          isAadhaarBackUploaded: mergeStoredKycUploadFlag(
            state.isAadhaarBackUploaded,
            payload.isAadhaarBackUploaded,
          ),
          ...nextCkycVerificationFromPayload(state, payload),
        };
      }

      case jarvisPrimeOnboardingConstants.PRIME_ONBOARDING_DATA_REQUEST: {
        return {
          ...state,
          loading: {
            ...state.loading,
            primeOnboardingData: 1,
          },
        };
      }

      case jarvisPrimeOnboardingConstants.PRIME_ONBOARDING_DATA_RESPONSE: {
        return {
          ...state,
          isInitialFetched: 1,
          currentStagePrime:
            payload.currentStagePrime ?? state.currentStagePrime,
          riskMasterId: payload.riskMasterId || state.riskMasterId,
          riskProfileName: payload.riskProfileName || state.riskProfileName,
          suggestedRiskId: payload.suggestedRiskId || state.suggestedRiskId,
          investmentAmount: payload.investmentAmount || state.investmentAmount,
          investmentTenure: payload.investmentTenure || state.investmentTenure,
          investmentStrategy: payload.investmentStrategy,
          isPrimeOnboardingCompleted:
            payload.isPrimeOnboardingCompleted ??
            state.isPrimeOnboardingCompleted,
          isPaymentCompleted:
            payload.isPaymentCompleted ?? state.isPaymentCompleted,
          minInvestmentAmount:
            payload.minInvestmentAmount || state.minInvestmentAmount,
          minimumAdditionalInvestAmount:
            // payload.minimumAdditionalInvestAmount ||
            // state.minimumAdditionalInvestAmount,
            (payload.minimumAdditionalInvestAmount && Number(payload.minimumAdditionalInvestAmount) !== 10000) ?
              payload.minimumAdditionalInvestAmount : 200000,
          portfolioGeneratedDate:
            payload.portfolioGeneratedDate || state.portfolioGeneratedDate,
          expiryDate: payload.expiryDate || state.expiryDate,
          dateOfBirth: payload.dateOfBirth || state.dateOfBirth,
          pan: payload.panNumber || payload.pan || state.pan,
          aadharNumber: payload.aadharNumber || state.aadharNumber,
          isPanUploaded: mergeStoredKycUploadFlag(
            state.isPanUploaded,
            payload.isPanUploaded,
          ),
          isAadhaarFrontUploaded: mergeStoredKycUploadFlag(
            state.isAadhaarFrontUploaded,
            payload.isAadhaarFrontUploaded,
          ),
          isAadhaarBackUploaded: mergeStoredKycUploadFlag(
            state.isAadhaarBackUploaded,
            payload.isAadhaarBackUploaded,
          ),
          ...nextCkycVerificationFromPayload(state, payload),
          loading: {
            ...state.loading,
            primeOnboardingData: 0,
          },
          planId: payload.planId || state.planId,
          hasOnboardingInvestmentDetailsConfirmed:
            payload.hasOnboardingInvestmentDetailsConfirmed ||
            state.hasOnboardingInvestmentDetailsConfirmed,
          customerSubscriptionId:
            payload.customerSubscriptionId || state.customerSubscriptionId,
          isMobileVerified: payload.isMobileVerified || state.isMobileVerified,
        };
      }

      case jarvisPrimeOnboardingConstants.PRIME_PORTFOLIO_DATA_REQUEST: {
        return {
          ...state,
          portfolioData: initialState.portfolioData,
          marketBreakupData: initialState.marketBreakupData,
          sectorBreakupData: initialState.sectorBreakupData,
          loading: {
            ...state.loading,
            portfolioData: 1,
          },
        };
      }

      case jarvisPrimeOnboardingConstants.PRIME_PORTFOLIO_DATA_RESPONSE: {
        return {
          ...state,
          portfolioData: payload.portfolioData || state.portfolioData,
          marketBreakupData:
            payload.marketBreakupData || state.marketBreakupData,
          sectorBreakupData:
            payload.sectorBreakupData || state.sectorBreakupData,
          loading: {
            ...state.loading,
            portfolioData: 0,
          },
        };
      }

      case jarvisPrimeOnboardingConstants.PRICING_DATA_REQUEST: {
        return {
          ...state,
          loading: {
            ...state.loading,
            pricingData: 1,
          },
          pricingData: initialState.pricingData,
        };
      }

      case jarvisPrimeOnboardingConstants.PRICING_DATA_RESPONSE: {
        return {
          ...state,
          loading: {
            ...state.loading,
            pricingData: 0,
          },
          pricingData: payload,
        };
      }

      case jarvisPrimeOnboardingConstants.PRIME_RESET_ONBOARDING_DATA: {
        return initialState;
      }

      default:
        return state;
    }
  },
);
